import React, { useState } from "react";
import EnterpriseGridCommon from "../Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";

const WpsReportTableAgGrid = ({ rows, isLoading, handleRowClick }) => {
  const { t } = useTranslation();

  const unitsCommonFilter = {
    pivot: true,
    floatingFilter: true,
    filter: "agMultiColumnFilter",
    filterParams: {
      maxNumConditions: 1,
      filters: [
        {
          filter: "agNumberColumnFilter",
          filterParams: {
            valueFormatter: (params) => {
              return Number(params.value);
            },
            maxNumConditions: 1,
          },
        },
      ],
    },
    pivotComparator: (a, b) => b.localeCompare(a),
  };

  const [columnDefs] = useState([
    {
      headerName: t("pqrReport.passName"),
      field: "passName",
      key: "passName",
      minWidth: 200,

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pqrReport.weldNo"),
      field: "weldNumber",
      key: "weldNumber",
      minWidth: 200,

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("pqrReport.torch"),
      field: "torch",
      key: "torch",
      minWidth: 200,

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: "Bug Type",
      field: "bugType",
      key: "bugType",
      minWidth: 200,

      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: `${t("pqrReport.preHeat")}`,
      field: "preHeatInterPassTemperature",
      key: "preHeatInterPassTemperature",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgVoltage")}`,
      field: "averageVoltage",
      key: "averageVoltage",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgCurrent")}`,
      field: "averageCurrent",
      key: "averageCurrent",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgWireFeedSpeed")}`,
      field: "averageWireFeedSpeed",
      key: "averageWireFeedSpeed",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgOscillationWidth")}`,
      field: "averageOscillationWidth",
      key: "averageOscillationWidth",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgOscillationFrq")}`,
      field: "averageOscillationFrequency",
      key: "averageOscillationFrequency",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgTravelSpeed")}`,
      field: "averageTravelSpeed",
      key: "averageTravelSpeed",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.arcEnergy")}`,
      field: "arcEnergy",
      key: "arcEnergy",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgPulseFrequency")}`,
      field: "averagePulseFrequency",
      key: "averagePulseFrequency",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgPulseTime")}`,
      field: "averagePulseTime",
      key: "averagePulseTime",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgPeakCurrent")}`,
      field: "averagePeakCurrent",
      key: "averagePeakCurrent",
      minWidth: 200,
      ...unitsCommonFilter,
    },
    {
      headerName: `${t("pqrReport.avgBaseCurrent")}`,
      field: "averageBaseCurrent",
      key: "averageBaseCurrent",
      minWidth: 200,
      ...unitsCommonFilter,
    },
  ]);

  const onRowClicked = (params) => {
    handleRowClick(params.data);
  };

  const handleFilterChanged = (params) => {
    console.log("Filter changed", params);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };

  return (
    <div
      className="ag-theme-alpine slog-grid-container"
      style={{ width: "100%" }}
    >
      <EnterpriseGridCommon
        rows={rows}
        columnDefs={columnDefs}
        isLoading={isLoading}
        onRowClicked={onRowClicked}
        exportFileName={"wps-limit"}
        handleFilterChanged={handleFilterChanged}
        processCellCallback={processCellCallback}
        heightValue={-80}
        slogData={true}
      />
    </div>
  );
};

export default WpsReportTableAgGrid;
